import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex-1 flex flex-column flex-center">
      <div className="alert alert-danger jumbotron text-center alert-inverse">
        <h2>{t('404_not_found')}</h2>
        <p>
          {t(
            'we_are_sorry_whatever_you_were_looking_for_isnt_here_or_it_may_has_been_removed'
          )}
        </p>
      </div>
    </div>
  );
}
